import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { animateScroll as scroll } from 'react-scroll';

export const FormErrorComponent = () => {
  const errorMessages = useSelector((state) => state.formUserInteractionReducer.errorMessages);

  useEffect(() => {
    scroll.scrollToBottom();
  });

  return (
    <div className="contain text-center result show-results">
      <div>
        <h2>Er is iets fout gegaan</h2>
        {errorMessages.map((error) => (
          <p key={error}>{error}</p>
        ))}
      </div>
    </div>
  );
};
